import ko from "knockout";
import featureToggleService from "services/featureToggleService";

/**
 * A binding handler for including a section of markup in the document (
 * and to have its data-bind attributes applied), only if a specified feature flag is NOT enabled.
 *
 * # Required arguments
 *
 * @param {String} value - The name of the feature flag that should be checked
 *
 * # Example
 *
 * <!-- ko notFeatureToggle: 'conferencing' -->
 *     <div></div>
 * <!-- /ko -->
 *
 */

ko.bindingHandlers.notFeatureToggle = {
    init(element, valueAccessor, allBindings, viewModel, bindingContext) {
        // Initially hide everything to not show hidden features for a little bit before the feature toggles are
        // fetched for the first time.
        const feature = ko.unwrap(valueAccessor()),
            enabled = featureToggleService.getFeatureToggle(feature);

        ko.bindingHandlers.ifnot.init(
            element,
            enabled,
            allBindings,
            viewModel,
            bindingContext
        );

        // Prevent inner bindings from being bound twice
        return { controlsDescendantBindings: true };
    },
};

ko.virtualElements.allowedBindings.notFeatureToggle = true;
